import { Create, useForm } from "@refinedev/antd";
import { HttpError } from "@refinedev/core";
import { Form, Input, InputNumber } from "antd";
import { ImageUpload } from "../../components/ImageUpload";

export function CategoryCreate() {
  const { formProps, saveButtonProps, formLoading } = useForm<any, HttpError, any>({
    resource: "category",
    successNotification: (data) => {
      return {
        message: data?.data.message,
        type: "success",
      };
    },
    action: "create",
  });

  return (
    <Create saveButtonProps={saveButtonProps} isLoading={formLoading} title="Create category">
      <Form {...formProps} layout="vertical">
        <Form.Item label="Title" name={["title"]} rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Description" name={["description"]}>
          <Input.TextArea />
        </Form.Item>

        <Form.Item label="Rank" name={["rank"]} initialValue={0}>
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item label="Image" name="mediaID">
          <ImageUpload uploadType="CATEGORY" />
        </Form.Item>
      </Form>
    </Create>
  );
}







